// Configuração global de administração — extraído de App.jsx — Fase C
import { normalizeAdminNotificationSettings } from "./adminNotificationPrefs";
import { normalizeModuleCardsConfig } from "./moduleCards";
import { normalizePastureCapacityConfig } from "./pastureCapacity";
import { normalizeFarmClimateProfile, normalizeFarmClimateProfiles } from "./climateConfig";
import { normalizeNotificationSyncSettings } from "./notificationsSync";
import { normalizeLiveActivitySettings } from "./liveActivitySettings";

const ADMIN_GLOBALS_CONFIG_DEFAULT = Object.freeze({
  id: "admin_globals_config",
  clientId: "admin_globals_config",
  showSuppliersButtonInModules: false,
  showProvidersButtonInModules: false,
  showCatalogButtonInModules: true,
  purchaseEditWindowMode: "always",
  purchaseEditWeekStartDay: 2,
  purchaseEditWeekStartTime: "14:00",
  purchaseEditWeekEndDay: 2,
  purchaseEditWeekEndTime: "12:00",
  moduleCardsConfig: {},
  pastureCapacityConfig: normalizePastureCapacityConfig(null),
  farmClimateProfiles: normalizeFarmClimateProfiles(null),
  climateGlobalProfile: normalizeFarmClimateProfile(null),
  climateCronSettings: { cronKey: '', notes: '', updatedAt: '', updatedBy: '', configInSync: false, configHasKey: false, dbHasKey: false },
  notificationSettings: normalizeAdminNotificationSettings(null),
  notificationSyncSettings: normalizeNotificationSyncSettings(null),
  liveActivitySettings: normalizeLiveActivitySettings(null),
  farmGenerationLogoutDelaySeconds: 30,
  nativeDeviceStaleDays: 30,
});

function normalizeAdminGlobalsConfig(input){
  const base = input && typeof input === "object" ? input : {};
  const toDay = (value, fallback) => {
    const n = Number(value);
    return Number.isFinite(n) ? Math.max(0, Math.min(6, Math.trunc(n))) : fallback;
  };
  const toTime = (value, fallback) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(String(value || "")) ? String(value) : fallback;
  const mode = String(base.purchaseEditWindowMode || ADMIN_GLOBALS_CONFIG_DEFAULT.purchaseEditWindowMode || "always");
  return {
    ...ADMIN_GLOBALS_CONFIG_DEFAULT,
    ...base,
    id: "admin_globals_config",
    clientId: "admin_globals_config",
    showSuppliersButtonInModules: typeof base.showSuppliersButtonInModules === "boolean" ? base.showSuppliersButtonInModules : ADMIN_GLOBALS_CONFIG_DEFAULT.showSuppliersButtonInModules,
    showProvidersButtonInModules: typeof base.showProvidersButtonInModules === "boolean" ? base.showProvidersButtonInModules : ADMIN_GLOBALS_CONFIG_DEFAULT.showProvidersButtonInModules,
    showCatalogButtonInModules: typeof base.showCatalogButtonInModules === "boolean" ? base.showCatalogButtonInModules : ADMIN_GLOBALS_CONFIG_DEFAULT.showCatalogButtonInModules,
    purchaseEditWindowMode: mode === "weekly" ? "weekly" : "always",
    purchaseEditWeekStartDay: toDay(base.purchaseEditWeekStartDay, ADMIN_GLOBALS_CONFIG_DEFAULT.purchaseEditWeekStartDay),
    purchaseEditWeekStartTime: toTime(base.purchaseEditWeekStartTime, ADMIN_GLOBALS_CONFIG_DEFAULT.purchaseEditWeekStartTime),
    purchaseEditWeekEndDay: toDay(base.purchaseEditWeekEndDay, ADMIN_GLOBALS_CONFIG_DEFAULT.purchaseEditWeekEndDay),
    purchaseEditWeekEndTime: toTime(base.purchaseEditWeekEndTime, ADMIN_GLOBALS_CONFIG_DEFAULT.purchaseEditWeekEndTime),
    moduleCardsConfig: normalizeModuleCardsConfig(base.moduleCardsConfig),
    pastureCapacityConfig: normalizePastureCapacityConfig(base.pastureCapacityConfig),
    farmClimateProfiles: normalizeFarmClimateProfiles(base.farmClimateProfiles),
    climateGlobalProfile: normalizeFarmClimateProfile(base.climateGlobalProfile),
    climateCronSettings: {
      cronKey: String(base?.climateCronSettings?.cronKey || base?.climateCronSettings?.cron_key || ''),
      notes: String(base?.climateCronSettings?.notes || ''),
      updatedAt: String(base?.climateCronSettings?.updatedAt || base?.climateCronSettings?.updated_at || ''),
      updatedBy: String(base?.climateCronSettings?.updatedBy || base?.climateCronSettings?.updated_by || ''),
      configInSync: !!(base?.climateCronSettings?.configInSync ?? base?.climateCronSettings?.config_in_sync),
      configHasKey: !!(base?.climateCronSettings?.configHasKey ?? base?.climateCronSettings?.config_has_key),
      dbHasKey: !!(base?.climateCronSettings?.dbHasKey ?? base?.climateCronSettings?.db_has_key),
    },
    notificationSettings: normalizeAdminNotificationSettings(base.notificationSettings),
    notificationSyncSettings: normalizeNotificationSyncSettings(base.notificationSyncSettings),
    liveActivitySettings: normalizeLiveActivitySettings(base.liveActivitySettings),
    farmGenerationLogoutDelaySeconds: [30,60,180,420,600].includes(Number(base.farmGenerationLogoutDelaySeconds)) ? Number(base.farmGenerationLogoutDelaySeconds) : 30,
    nativeDeviceStaleDays: (() => {
      const n = Number(base.nativeDeviceStaleDays ?? ADMIN_GLOBALS_CONFIG_DEFAULT.nativeDeviceStaleDays);
      return Number.isFinite(n) ? Math.max(1, Math.min(180, Math.trunc(n))) : 30;
    })(),
  };
}

export { ADMIN_GLOBALS_CONFIG_DEFAULT, normalizeAdminGlobalsConfig };
